import { ContentComponent, ContentComponentReplaced } from "@/content-V2/types";

export type ComponentReplacer<T> = (component: ContentComponentReplaced<T>, index: number) => T;

function replaceContentComponentProperty<T>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  propertyValue: any,
  index: number,
  replacer: ComponentReplacer<T>
): T | T[] {
  if (Array.isArray(propertyValue)) {
    return propertyValue.map((item, i) =>
      replaceContentComponentProperty<T>(item, i, replacer)
    ) as T[];
  }

  if (typeof propertyValue === "object" && propertyValue !== null) {
    if ("_isContentComponent" in propertyValue && propertyValue._isContentComponent === true) {
      return replaceContentComponent<T>(propertyValue, index, replacer) as T;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: Record<string, any> = {};

    for (const key in propertyValue) {
      if (propertyValue.hasOwnProperty(key)) {
        const value = propertyValue[key];
        result[key] = replaceContentComponentProperty<T>(value, index, replacer);
      }
    }

    return result as T;
  }

  return propertyValue as T;
}

function replaceContentComponent<T>(
  contentComponent: ContentComponent,
  index: number,
  replacer: ComponentReplacer<T>
): T {
  const { props, ...other } = contentComponent;
  const replacedProps = replaceContentComponentProperty<T>(props, index, replacer);
  // @ts-ignore
  return replacer(
    {
      ...other,
      // @ts-ignore
      props: replacedProps
    },
    index
  );
}

export function replaceContentComponents<T>(
  input: ContentComponent[],
  replacer: ComponentReplacer<T>
): T[] {
  return input.map((item, index) => replaceContentComponent<T>(item, index, replacer));
}
